module.exports = __webpack_public_path__ + "static/img/xiazaijietu2.04b900a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazaijietu2.png
// module id = crE8
// module chunks = 24